import { render, staticRenderFns } from "./TheRoadmapEditPriorities.vue?vue&type=template&id=bbe091de&scoped=true&"
import script from "./TheRoadmapEditPriorities.vue?vue&type=script&lang=ts&"
export * from "./TheRoadmapEditPriorities.vue?vue&type=script&lang=ts&"
import style0 from "./TheRoadmapEditPriorities.vue?vue&type=style&index=0&id=bbe091de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe091de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbe091de')) {
      api.createRecord('bbe091de', component.options)
    } else {
      api.reload('bbe091de', component.options)
    }
    module.hot.accept("./TheRoadmapEditPriorities.vue?vue&type=template&id=bbe091de&scoped=true&", function () {
      api.rerender('bbe091de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheRoadmapEditPriorities.vue"
export default component.exports